// material-ui
import { IconButton, Tooltip } from '@mui/material';

// assets
import { IconPin } from '@tabler/icons';

// project imports
import useConfig from 'hooks/useConfig';

// Pogozo teal — matches the Calendar panel's accent and the pogozo-web pin affordance
const TEAL = '#00bfb3';

// ==============================|| TASK PANEL PIN TOGGLE ||============================== //

/**
 * Header toggle that pins / unpins the shell-mounted Tasks dock (POGO-13786).
 * Mirrors the pogozo-web treatment-note pin: a Tabler IconPin whose fill turns
 * teal when pinned and `none` when not. The pinned choice lives in ConfigContext
 * (`berry-config-ts`), so it is durable across routes, reloads and browser tabs.
 */
const TaskPinSection = () => {
    const { taskPanelPinned, onChangeTaskPanelPinned } = useConfig();

    const label = taskPanelPinned ? 'Unpin tasks panel' : 'Pin tasks panel';

    return (
        <Tooltip title={label}>
            <IconButton aria-label={label} onClick={() => onChangeTaskPanelPinned(!taskPanelPinned)} size="large">
                <IconPin stroke={1.5} size="1.3rem" color={taskPanelPinned ? TEAL : undefined} fill={taskPanelPinned ? TEAL : 'none'} />
            </IconButton>
        </Tooltip>
    );
};

export default TaskPinSection;
